import apiZervant from '../../utils/apiZervant'
import { ZervantSubscriptionPayment } from './types/zervantSubscriptionPayment'
import { ZervantSubscriptionPlan } from './types/zervantSubscriptionPlan'
import { ZervantSubscriptionQuota } from './types/zervantSubscriptionQuota'

export interface ZervantSubscription {
  id: string
  status: string
  plan: ZervantSubscriptionPlan
  quotas: ZervantSubscriptionQuota[]
  payment: ZervantSubscriptionPayment | null
  currentPeriodEnd: number | null
  inDowngrade: boolean
  downgradeAt: number | null
  downgradeTo: string | null
  cancelAt: number | null
  lastPremiumEndDate?: number
}

export const fetchZervantSubscription = async () => apiZervant.subscription.get<ZervantSubscription>('/my-subscription')

interface ZervantPortalResponseData {
  url: string
}

export const fetchZervantPortal = async (flow?: string) =>
  apiZervant.subscription.get<ZervantPortalResponseData>('/portal', { params: flow ? { flow } : undefined })
